import React from "react";
import Container from "@material-ui/core/Container";
import PageContainer from "components/PageContainer";
import useStyles from "./styles";
import Routes from "routers";
import configTheme from "./configTheme";

import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { BrowserRouter } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";

const ConfigApp = props => {
	const { infoShop } = props;
	const business = infoShop?.business || "TAC";

	const theme = createTheme(configTheme[business]);

	return (
		<ThemeProvider theme={theme}>
			<MainContainer />
		</ThemeProvider>
	);
};

const MainContainer = React.memo(
	() => {
		const classes = useStyles();
		return (
			<Grid classes={{ root: classes.background }}>
				<Container maxWidth="xs" classes={{ root: classes.root }}>
					<BrowserRouter>
						<PageContainer>
							<Routes />
						</PageContainer>
					</BrowserRouter>
				</Container>
			</Grid>
		);
	},
	() => {
		return true;
	}
);

const mapStateToProps = state => {
	return {
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigApp);
